import { filterObj } from "@/utils/util";

export default {
	data() {
		return {
			/* 数据源 */
			dataSource: []
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		/*获取参数*/
		getParameters() {
			var param = { ...this.queryParam,...this.queryParamFixed };
			return filterObj(param);
		},
		/*加载数据*/
		loadData(pageNumber) {
			if (!this.listUrl) {
				this.$message.error("请设置listUrl属性!");
				return
			}
			let params = this.getParameters();
			params['pageNum'] = pageNumber ? pageNumber : this.current;
			params['pageSize'] = this.pageSize;
			//清空选择项
			this.getAction({ url: this.listUrl, params: params }).then((data) => {
				this.dataSource = data.records;
				this.current = parseInt(data.current) || 1;
				this.total = parseInt(data.total);
                this.pagination.total = parseInt(data.total);
				this.pageSize = parseInt(data.size);
			}).catch(() => {

			})
		},
		/*分页方法*/
		onChange(current) {
			this.loadData(current)
		},
		/*搜索方法*/
		getSearch(param) {
			this.queryParam.srh_name = param
			this.loadData()
		},
		/*筛选条件*/
		getFilterSearch(param) {
			this.queryParam = { ...param };
			this.loadData()
		}
	}
}
